import { buildParams } from '../../helpers/path';
import { PaginationRequest } from '../../types/pagination';
import { DefaultRequest } from '../../types/props';
import { AdminType } from './admins-api';
import { managerApiUrl } from './manager-api';
import { baseFetch } from './utils.ts/base-fetch';

export type RolePermission = 'read' | 'write';
export type RoleScope = 'company' | 'branch' | 'role';

export type RoleType = {
  id: string;
  name: string;
  scope: RoleScope;
  based_on?: string;
  employees?: AdminType[];
  permissions: {
    dashboard?: RolePermission;
    monitoring?: RolePermission;
    qr?: RolePermission;
    review?: RolePermission;
    tree?: RolePermission;
    task?: RolePermission;
    staff?: RolePermission;
    menu?: RolePermission;
    lead?: RolePermission;
    promotion?: RolePermission;
    form?: RolePermission;
    device?: RolePermission;
    profile?: RolePermission;
  };
};

const baseUrl = `${managerApiUrl}/role`;

export const fetchRoleById = async (id: string): Promise<RoleType> => {
  const resp = await baseFetch(baseUrl + '?id=' + id);
  return resp.data;
};

export type FetchRolesRequest = DefaultRequest & PaginationRequest;
export const fetchRoles = async (data: FetchRolesRequest): Promise<RoleType[]> => {
  const resp = await baseFetch(baseUrl + buildParams(data));
  return resp.data;
};

export const postRole = async (data: Partial<RoleType>): Promise<RoleType> => {
  const resp = await baseFetch(baseUrl, {
    method: 'POST',
    body: JSON.stringify(data),
  });
  return resp.data;
};

export const putRole = async (data: Partial<RoleType>): Promise<RoleType> => {
  const resp = await baseFetch(baseUrl + buildParams({ id: data.id }), {
    method: 'PUT',
    body: JSON.stringify(data),
  });
  return resp.data;
};

export const deleteRole = async (id: string): Promise<void> => {
  await baseFetch(baseUrl + buildParams({ id }), {
    method: 'DELETE',
  });
};
